import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

export function BotScheduleSettings() {
  const schedule = [
    { day: 'Lunes', hours: '8:00 AM - 8:00 PM', active: true },
    { day: 'Martes', hours: '8:00 AM - 8:00 PM', active: true },
    { day: 'Miércoles', hours: '8:00 AM - 8:00 PM', active: true },
    { day: 'Jueves', hours: '8:00 AM - 8:00 PM', active: true },
    { day: 'Viernes', hours: '8:00 AM - 8:00 PM', active: true },
    { day: 'Sábado', hours: '9:00 AM - 5:00 PM', active: true },
    { day: 'Domingo', hours: 'Desactivado', active: false }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5" />
          Horarios de Atención
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {schedule.map((item, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-3">
                <span className="font-medium text-sm min-w-[80px]">{item.day}</span>
                <span className="text-sm text-muted-foreground">{item.hours}</span>
              </div>
              <Badge variant={item.active ? "default" : "secondary"}>
                {item.active ? "Activo" : "Inactivo"}
              </Badge>
            </div>
          ))}
        </div>
        
        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-900">
            <strong>Nota:</strong> Fuera de estos horarios, tu bot enviará un mensaje 
            automático informando cuándo estará disponible nuevamente.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}